import React from "react";

function TickIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

function PendingIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
    </svg>
  );
}

export function CompletionSidebar({ steps, currentStep, lastCompletedStep = 0, onGoToStep }) {
  return (
    <aside className="business-completion-sidebar">
      <nav className="completion-steps-nav" aria-label="Profile steps">
        {steps.map((step) => {
          const isCompleted = step.id <= lastCompletedStep;
          const isCurrent = step.id === currentStep;
          const isPending = !isCompleted && !isCurrent;
          return (
            <button
              key={step.id}
              type="button"
              className={`completion-step-nav-item ${isCurrent ? "current" : ""} ${isCompleted ? "completed" : ""} ${isPending ? "pending" : ""}`}
              onClick={() => onGoToStep(step.id)}
              aria-current={isCurrent ? "step" : undefined}
              aria-label={isCompleted ? `${step.title} (completed)` : isPending ? `${step.title} (pending)` : step.title}
            >
              <span className="completion-step-nav-icon">
                {isCompleted && <span className="completion-step-nav-dot completed-dot" aria-hidden />}
                {isCurrent && <span className="completion-step-nav-num">{step.id}</span>}
                {isPending && <span className="completion-step-nav-pending"><PendingIcon /></span>}
              </span>
              <span className="completion-step-nav-title">{step.title}</span>
              <span className="completion-step-nav-right">
                {isCompleted && <span className="completion-step-nav-tick" aria-hidden><TickIcon /></span>}
                {isPending && <span className="completion-step-nav-pending-right" aria-hidden><PendingIcon /></span>}
              </span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
}
